import { AddressFieldClass } from './component/AddressFieldClass';
import { refs } from '@descope-ui/theme-input-wrapper';

const vars = AddressFieldClass.cssVarList;

const addressField = {
  [vars.hostWidth]: refs.width,
  [vars.hostDirection]: refs.direction,

  _fullWidth: {
    [vars.hostWidth]: '100%',
  },
};

export default addressField;
export { vars };
